<template>
	<div>
		<b-navbar fixed="top" variant="white" class="shadow">
			<div class="container">
				<b-navbar-brand :to="{ name: 'components' }">
					<img
						:src="require('@/assets/img/logo.jpg')"
						alt="Mobil"
						class="img-fluid"
						style="height: auto; width: 100%; max-width: 150px"
					/>
				</b-navbar-brand>
			</div>
		</b-navbar>
		<div class="container mt-4 text-dark" style="padding-top: 80px">
			<h1 class="mb-4 text-dark">T&Eacute;RMINOS Y CONDICIONES</h1>
			<ol>
				<li>
					<span
						>Solo podr&aacute;n ser parte de la din&aacute;mica, los clientes
						que se hayan registrado con informaci&oacute;n correcta y veraz, con
						apellido materno, apellido paterno, correo, fecha de nacimiento,
						sexo y al menos un medio de contacto adicional activo
						(tel&eacute;fono o domicilio). Y que hayan registrado sus tickets de
						compra correctamente de acuerdo a la mec&aacute;nica establecida.
						(Monto de compra, fecha y c&oacute;digo de
						facturaci&oacute;n).</span
					>
				</li>
				<li>
					<span
						>El cliente es responsable de validar que su informaci&oacute;n
						registrada sea correcta, as&iacute; como que su correo sea el que
						usa y est&eacute; activa su cuenta.&nbsp;</span
					>
				</li>
				<li>
					<span
						>Los clientes que se registren deber&aacute;n proporcionar sus datos
						personales completos y de forma ver&iacute;dica, ya que en caso de
						resultar acreedor, el incentivo le ser&aacute; entregado
						&uacute;nicamente si los documentos con los que se identifican,
						corresponden a los datos proporcionados en su registro.&nbsp;</span
					>
				</li>
				<li>
					<span
						>Los clientes que registren datos ficticios o exista irregularidades
						con sus definiciones como plagio, ser&aacute;n descalificados,
						siendo esta decisi&oacute;n inapelable.&nbsp;</span
					>
				</li>
				<li>
					<span
						>Solo podr&aacute;n ser parte de la din&aacute;mica aquellas
						personas f&iacute;sicas con domicilio en la Rep&uacute;blica
						Mexicana, incluyendo extranjeros con residencia en la misma y que
						cumplan con todos y cada uno de los requisitos establecidos en estas
						Bases.&nbsp;</span
					>
				</li>
				<li>
					<span
						>Los clientes que sean parte del concurso deber&aacute;n ser mayores
						de edad, seg&uacute;n lo establece la Ley respectiva y
						deber&aacute;n otorgar pleno consentimiento para el uso y
						explotaci&oacute;n de los derechos de su imagen y nombre para fines
						promocionales y publicitarios relacionados con esta
						Promoci&oacute;n.&nbsp;</span
					>
				</li>
				<li>
					<span
						>&Uacute;nicamente podr&aacute;n ser parte de la promoci&oacute;n
						las personas que durante la Vigencia establecida, cumplan con la
						condici&oacute;n de participaci&oacute;n y requisitos
						se&ntilde;alados para poder ser acreedores a uno de los
						incentivos.&nbsp;</span
					>
				</li>
				<li>
					<span
						>Si el participante decide ser parte de la Promoci&oacute;n, implica
						que conoce y acepta el total de la mec&aacute;nica, t&eacute;rminos
						y condiciones de la misma. Cada cliente acepta obligarse por las
						reglas y disposiciones de las presentes Bases, las cuales
						tendr&aacute;n car&aacute;cter definitivo en todos los asuntos
						relacionados a esta Promoci&oacute;n.&nbsp;</span
					>
				</li>
				<li>
					<span
						>Todos los clientes deber&aacute;n contar con la confirmaci&oacute;n
						de registro enviada a su correo electr&oacute;nico registrado y su o
						sus tickets de compra dentro del tiempo de la Vigencia de la
						Promoci&oacute;n.</span
					>
				</li>
				<li>
					<span
						>Quedar&aacute;n fuera de la promoci&oacute;n aquellos clientes que
						no re&uacute;nan las condiciones para participar en la
						Promoci&oacute;n o bien aqu&eacute;llos que no cumplan con
						cualquiera de los t&eacute;rminos y condiciones establecidos en las
						presentes Bases.&nbsp;</span
					>
				</li>
				<li>
					<span
						>Los acreedores (ganadores) ser&aacute;n responsables por cualquier
						otro gasto, impuesto y/o tasa no especificada expresamente en estas
						Bases. Todos los costos, gastos, impuestos y/o tasas no mencionados
						como incluidos se entienden expresamente excluidos, sin que los
						mismos sean responsabilidad del Organizador o de cualquier otra
						empresa de la marca participante.&nbsp;</span
					>
				</li>
				<li>
					<span
						>Solo podr&aacute;n ser parte de la din&aacute;mica, los clientes
						que hayan enviado correctamente al correo&nbsp;</span
					><a href="http://www.mobilracing.mx"
						><span>www.mobilracing.mx</span></a
					><span
						>&nbsp; con el
						<strong>asunto &ldquo;LA GRAN CARRERA MOBIL&rdquo;</strong> la
						evidencia de su ticket de compra.</span
					>
				</li>
				<li>
					<span
						>Se deber&aacute; conservar el o los tickets de compra en original
						que dieron el derecho al cliente a ser parte de la din&aacute;mica y
						presentarlos el d&iacute;a de la entrega del incentivo. En caso de
						resultar acreedor y no se presenten &nbsp;los tickets de compra en
						original, no se podr&aacute; realizar entrega del incentivo y sin
						responsabilidad para la empresa responsable de la
						din&aacute;mica.&nbsp;</span
					>
				</li>
				<li>
					<span
						>No podr&aacute;n ser parte de la din&aacute;mica, el personal
						contratado por cualquiera de las empresas pertenecientes a MOBIL y
						sus respectivas agencias, afiliadas, matrices, subsidiarias;
						as&iacute; como cualquier otra persona involucrada en la
						producci&oacute;n y/o desarrollo de la din&aacute;mica.&nbsp;</span
					>
				</li>
				<li>
					<span
						>&Uacute;nicamente participan los tickets registrados por las
						compras realizadas dentro del periodo de vigencia y que cumplan con
						la condici&oacute;n de participaci&oacute;n.</span
					>
				</li>
				<li>
					<span
						>No participan los tickets de compra con fecha fuera de la vigencia
						de la promoci&oacute;n, ni devoluciones.</span
					>
				</li>
				<li>
					<span
						>El incentivo no podr&aacute; ser rembolsable por dinero en
						efectivo, ni sustituido por un bien o servicio diferente al
						ofrecido.&nbsp;</span
					>
				</li>
				<li>
					<span
						>El incentivo otorgado no incluye gastos de vi&aacute;ticos ni
						transporte.&nbsp;</span
					>
				</li>
				<li>
					<span
						>El Organizador se reserva el derecho de sustituir el incentivo por
						uno de igual o mayor valor en el caso que, por circunstancias ajenas
						a la voluntad del Organizador, no pueda ser proporcionado los
						acreedores.&nbsp;</span
					>
				</li>
				<li>
					<span
						>El cliente es responsable de revisar el correo que hayan registrado
						para participar en la din&aacute;mica, incluyendo la secci&oacute;n
						de correos no deseados y de Spam.</span
					>
				</li>
				<li><span>Limitado a un incentivo por acreedor.&nbsp;</span></li>
				<li>
					<span
						>El incentivo es intransferible, por lo que no podr&aacute; ser
						redimido por una persona distinta del acreedor.</span
					>
				</li>
				<li>
					<span
						>MOBIL y el organizador no son responsables por fallas
						t&eacute;cnicas de cualquier clase (computadoras, cables, red,
						hardware o software), o la indisponibilidad o inaccesibilidad de
						cualquier servicio de Internet. &nbsp;</span
					>
				</li>
				<li>
					<span
						>El incentivo, ser&aacute; entregado de conformidad con lo
						establecido en las bases de esta din&aacute;mica.&nbsp;</span
					>
				</li>
				<li>
					<span
						>Para el incentivo
						<strong>&ldquo;LA GRAN CARRERA MOBIL&rdquo;</strong> la
						participaci&oacute;n es por cada compra de gasolina (ticket ).
						Limitado a 10 incentivos.&nbsp;</span
					>
				</li>
				<li>
					<span
						>MOBIL e Imaquinando S.A de C.V. se reservan el derecho de modificar
						las bases y/o din&aacute;mica de la promoci&oacute;n, previa
						notificaci&oacute;n a trav&eacute;s de la p&aacute;gina corporativa
						en Internet y en&nbsp;</span
					><a href="http://www.mobilracing.mx"
						><span>www.mobilracing.mx</span></a
					><span
						style="
							font-family: 'Arial Rounded MT Bold', sans-serif;
							color: windowtext;
						"
						>&nbsp;,&nbsp;</span
					><span style=" ;"
						>as&iacute; como ante la autoridad correspondiente.&nbsp;</span
					>
				</li>
				<li>
					<span
						>Cualquier cliente que responda antes o despu&eacute;s de las horas
						estipuladas a la din&aacute;mica, ser&aacute;
						descalificado.&nbsp;</span
					>
				</li>
				<li>
					<span
						>Al ser parte de la promoci&oacute;n, en caso de resultar acreedor,
						los clientes aceptan y autorizan que los derechos de autor y/o
						propiedad intelectual de la fotograf&iacute;a premiada
						quedar&aacute; en propiedad exclusiva y permanente del Organizador,
						sus empresas filiales, subsidiarias y/o relacionadas, con la
						completa libertad para utilizarlo total o parcialmente o para
						modificarlo en el momento y la forma en que lo considere necesario.
						En el supuesto de resultar ganador, el participante conviene en
						celebrar cualquier documento que sea necesario a fin de que el
						Organizador y/o cualquiera de sus empresas filiales, subsidiarias o
						relacionadas exploten o usen las definiciones. Las autorizaciones
						anteriores incluyen el consentimiento expreso e irrevocable de usar
						o publicar su fotograf&iacute;a (retrato) en cualquier medio que se
						considere conveniente en t&eacute;rminos del art&iacute;culo 87 de
						la Ley Federal del Derecho de Autor (entendiendo que la
						participaci&oacute;n en el concurso y la aceptaci&oacute;n del
						incentivo se traduce para efectos de este precepto legal en una
						contraprestaci&oacute;n para dejarse retratar en el momento en que
						se le entregue el incentivo). Los clientes aceptan que el presente
						concurso no otorga licencia alguna, o alg&uacute;n tipo de derecho
						respecto de la Propiedad Intelectual del Organizador, sus empresas
						filiales, subsidiarias y/o relacionadas.</span
					>
				</li>
				<li>
					<span
						>Es responsabilidad del cliente verificar que sus datos, nombre y
						correo, sean correctos y actuales. En caso de requerir alguna
						modificaci&oacute;n o cambio deber&aacute; ser solicitada al
						correo&nbsp;</span
					><a href="http://www.mobilracing.mx"
						><span>www.mobilracing.mx</span></a
					><span>&nbsp;o a&nbsp;</span
					><a href="mailto:hola@imakinando.mx"
						><span>hola@imakinando.mx</span></a
					><span>&nbsp;a m&aacute;s tardar el 25 de Octubre del 2021.</span>
				</li>
				<li>
					<span
						>El horario de atenci&oacute;n para cualquier tema referente a la
						din&aacute;mica o al sitio de&nbsp;</span
					><a href="http://www.mobilracing.mx"
						><span style=" ;">www.mobilracing.mx</span></a
					><span>&nbsp;</span
					><span
						>ser&aacute; de lunes a viernes de 09:00 hrs a 18:00 hrs durante la
						vigencia de la misma, tomando en consideraci&oacute;n las fechas
						establecidas para aclaraci&oacute;n de su registro.</span
					>
				</li>
			</ol>
		</div>
		<FooterBack></FooterBack>
	</div>
</template>
<script>
import FooterBack from "./components/FooterBack";
export default {
	name: "terminos",
	components: {
		FooterBack,
	},
};
</script>
